// START MODULE TABLE REPLICATION SKELETON //

import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Entities } from 'src/common/index';
import composeModalActions from 'src/utils/modal-action-wrapper';
import TableHelper from 'src/utils/table-helper';
import ErrorMessage from 'src/components/misc/error-message';
import { withTranslation } from 'react-i18next';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import NotificationAdministrationModal from 'src/components/superadmin/notifications/components/notification-administration-modal';

class NotificationTable extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        // Use a specific helper instance for notifications
        this.tableHelper = new TableHelper();
    }

    render() {
        const { notifications, selectedCompany, t } = this.props; // Renamed props destructuring
        const finishFetching = !notifications.isFetching;

        const tableData = [];
        if (finishFetching && notifications.items.length > 0) {
            notifications.items.forEach(notification => {
                tableData.push({
                    id: notification.id,
                    type: notification.type,
                    text: notification.text,
                    title: notification.title.de,
                    createdAt: new Date(notification.createdAt).toLocaleString('de-DE'),
                });
            });
        }

        return (
            <div>
                {(() => {
                    if (notifications.error)
                        return <ErrorMessage object={notifications} />; // Use notifications prop
                    else
                        return (
                            <div id="company-list-panel">
                                <BootstrapTableErrorBoundary>
                                    <BootstrapTable
                                        ref={ref => (this.table = ref)}
                                        data={tableData}
                                        exportCSV={true}
                                        striped={true}
                                        hover={true}
                                        condensed={true}
                                        pagination={true}
                                        options={Object.assign({}, this.tableHelper.getOptions(finishFetching))}
                                        selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                                        searchPlaceholder={t('common_phrases.search')}
                                        search={true}>
                                        <TableHeaderColumn
                                            columnTitle={true}
                                            dataField="id"
                                            isKey={true}
                                            export={true}
                                            width="50">
                                            {t('common_phrases.id')}
                                        </TableHeaderColumn>
                                        {/* Adapt type column */}
                                        <TableHeaderColumn
                                            columnTitle={true}
                                            dataField="type"
                                            dataSort={true}
                                            width="100">
                                            {t('common_phrases.type')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            columnTitle={true}
                                            dataField="createdAt"
                                            dataSort={true}
                                            width="200">
                                            {t('operator_notifications.admin.created_at')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            columnTitle={true}
                                            dataField="title"
                                            dataFormat={this.htmlFormatter}>
                                            {t('operator_notifications.admin.title')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            columnTitle={true}
                                            dataField="actions"
                                            width="90"
                                            dataFormat={this.tableActionsFormatter}
                                            export={false}>
                                            {t('common_phrases.actions')}
                                        </TableHeaderColumn>
                                    </BootstrapTable>
                                </BootstrapTableErrorBoundary>
                            </div>
                        );
                })()}
            </div>
        );
    }

    htmlFormatter(cellValue) {
        if (!cellValue) return '';
        return <span dangerouslySetInnerHTML={{ __html: cellValue }} />;
    }

    // Adapts delete function to Notification entity
    onProceedDelete(notification) {
        const { selectedCompany } = this.props;

        this.props.deleteById(notification.id, Entities.NOTIFICATION, selectedCompany);
    }

    openConfirmDeleteDialog(notification) {
        const { t } = this.props;

        // this.table.reset();
        // this.props.openModal({
        //     component: ConfirmDialog,
        //     componentProps: {
        //         event: notification,
        //         onProceedDialog: this.onProceedDelete,
        //         bodyText: t('user_functionality.confirm_delete_s', { entity: t('notification') }), // Adapt translation key
        //         proceedText: t('user_functionality.delete'),
        //         cancelText: t('common_phrases.no'),
        //         cancelButtonColor: ButtonColors.NOTIFY,
        //         proceedButtonColor: ButtonColors.DANGER,
        //     },
        //     title: notification.type,
        //     noButtons: true,
        // });
    }

    tableActionsFormatter(cell, notification) {
        const { notifications, selectedCompany, t } = this.props; // Update props reference
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    onClick={() => {
                        this.props.openModal({
                            component: NotificationAdministrationModal,
                            componentProps: {
                                id: notification.id,
                                isCreate: false,
                                openModal: this.props.openModal,
                            },
                            title: t('user_functionality.edit'),
                            mandatoryFields: true,
                        });
                    }}>
                    <span title={t('user_functionality.edit')} className="glyphicon glyphicon-pencil text-info" />
                </button>
                {/*<button*/}
                {/*    type="button"*/}
                {/*    className="btn btn-xs transparent"*/}
                {/*    onClick={() => this.openConfirmDeleteDialog(notification)}>*/}
                {/*    <span title={t('user_functionality.delete')} className="glyphicon glyphicon-trash text-danger" />*/}
                {/*</button>*/}
            </div>
        );
    }
}

export default withTranslation()(composeModalActions(NotificationTable));
